import MroRepository from "./MroRepository";

export default class MroService {
    private readonly MroRepository: MroRepository = new MroRepository();

    async getMROReport({ startDate, endDate, infrastructure }: { startDate: string, endDate: string, infrastructure: any }): Promise<any> {
        return this.MroRepository.getMROReport(startDate, endDate, infrastructure);
    }
}
